var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"white--text xs12 sm6 offset-sm3"},[_c('div',[_c('img',{staticClass:"mx-2",attrs:{"src":_vm.companyIcon}})])])}
var staticRenderFns = []

export { render, staticRenderFns }